if (!customElements.get('product-customer-reviews')) {
  customElements.define('product-customer-reviews', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.track = this.querySelector('.pr-reviews__track');
      this.cards = [...this.querySelectorAll('.pr-reviews__card')];
      this.dots = [...this.querySelectorAll('[data-index]')];
      this.index = 0;
      if (!this.track || !this.cards.length) return;
      this.setAttribute('data-ready', '');
      const nav = this.querySelector('.pr-reviews__nav');
      if (nav) nav.hidden = false;
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-index')) this.go(Number(button.dataset.index));
        if (button.hasAttribute('data-direction')) this.go(this.index + Number(button.dataset.direction));
      }, options);
      this.track.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key) || event.target !== this.track) return;
        event.preventDefault();
        this.go(event.key === 'Home' ? 0 : event.key === 'End' ? this.cards.length - 1 : this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }, options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          const left = this.track.getBoundingClientRect().left;
          this.index = this.cards.reduce((best, card, i) => Math.abs(card.getBoundingClientRect().left - left) < Math.abs(this.cards[best].getBoundingClientRect().left - left) ? i : best, 0);
          this.update();
        });
      }, { ...options, passive: true });
      this.addEventListener('shopify:block:select', event => {
        const index = this.cards.findIndex(card => card.dataset.reviewId === event.detail.blockId);
        if (index >= 0) this.go(index, 'instant');
      }, options);
      this.resizeObserver = new ResizeObserver(() => this.go(this.index, 'instant'));
      this.resizeObserver.observe(this.track);
      this.cards.forEach(card => this.resizeObserver.observe(card));
      this.update();
    }
    go(index, behavior) {
      this.index = Math.max(0, Math.min(index, this.cards.length - 1));
      const distance = this.cards[this.index].getBoundingClientRect().left - this.track.getBoundingClientRect().left;
      this.track.scrollBy({ left: distance, behavior: behavior || (matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth') });
      this.update();
    }
    update() {
      // Each slide keeps its natural height, including when fonts or text change.
      const height = `${this.cards[this.index].offsetHeight}px`;
      if (this.track.style.height !== height) this.track.style.height = height;
      this.dots.forEach((dot, i) => {
        if (i === this.index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      const previous = this.querySelector('[data-direction="-1"]');
      const next = this.querySelector('[data-direction="1"]');
      if (previous) previous.disabled = this.index === 0;
      if (next) next.disabled = this.index === this.cards.length - 1;
      this.querySelector('[data-review-status]').textContent = `${this.index + 1} / ${this.cards.length}`;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}
